import React from "react";
import Tag from "./Tag";

const CandidateCard = ({ data }) => {
  const { name, currentJobtitle, currentcompany, extracted_summary, location, profilepicture } = data;


  const initials = name
    ?.split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);

  return (
    <div className="p-4 bg-white rounded-xl border border-gray-200 shadow-sm w-80">

      <div className="flex items-center">
        <div className="flex items-center justify-center w-10 h-10 rounded-full bg-blue-100 text-blue-700 font-semibold text-lg">
          {profilepicture ? (
            <img src={profilepicture}
              alt={name}
              className="w-full h-full object-cover"
            />) : (
            <span className="text-blue-700 font-semibold text-lg">
              {initials}
            </span>
          )}
        </div>

        <div className="ml-4 flex-1">
          <div className="flex items-center justify-between">
            <h2 className="font-semibold text-gray-900 text-sm">{name}</h2>
            <Tag variant={"success"} text={"onGoing"} />
          </div>

          <p className="text-sm text-textGray text-start">
            {currentJobtitle} {currentcompany ? `at ${currentcompany}` : ""}
          </p>
        </div>
      </div>
      <p className="text-sm text-primaryBlack mt-2 leading-snug line-clamp-2 text-start">
        {extracted_summary}
      </p>

      <p className="text-sm text-textGray mt-1 text-start">{location}</p>
    </div>
  );
};

export default CandidateCard;
